export default __webpack_public_path__ + "static/media/scrum-event-sheets-1.5c72a770.png";